import React from 'react';

const TourCard = ({ title, imageSrc, toursCount, link }) => (
  <div className="col-12 col-md-4 mb-4">
    <div className="elementor-widget-wrap elementor-element-populated text-center h-100">
      <div
        className="elementor-element elementor-widget elementor-widget-gva_ba_banner h-100"
        data-element_type="widget"
        data-widget_type="gva_ba_banner.default"
      >
        <div className="elementor-widget-container h-100">
          <div className="gva-element-gva_ba_banner gva-element h-100 d-flex flex-column justify-content-between">
            <div className="gsc-booking-banner text-left style-3 borderr">
              <div className="listings-banner-content pb-2">
                <div className="banner-image">
                  <img decoding="async" src={imageSrc} alt={title} />
                </div>
                <div className="banner-content">
                  <h3 className="title text-dark">{title}</h3>
                </div>
                <a href={link} className="thm-btn mt-2">Read More</a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const BookingBannerSection = () => {
  const tours = [
    { title: 'Online cab booking in Pune', imageSrc: '/images/service/1.jpg', toursCount: 3, link: '/Online-Cab-Booking-In-Pune' },
    { title: 'Pune to Kolhapur Cab', imageSrc: '/images/service/2.jpg', toursCount: 3, link: '/Pune-To-Kolhapur-Cab' },
    { title: 'Pune to Satara Cab', imageSrc: '/images/service/3.jpg', toursCount: 6, link: '/Pune-To-Satara-Cab' },
    { title: 'Pune to Hyderabad Cab', imageSrc: '/images/service/4.jpg', toursCount: 3, link: '/Pune-To-Hyderabad-Cab' },
    { title: 'Pune to Bangalore Cab', imageSrc: '/images/service/5.jpg', toursCount: 3, link: '/Pune-To-Bangalore-Cab' },
    { title: 'Pune to Indore Cab', imageSrc: '/images/service/6.jpg', toursCount: 6, link: '/Pune-To-Indore-Cab' },
    { title: 'Pune to Gujarat Cab', imageSrc: '/images/service/7.jpg', toursCount: 3, link: '/Pune-To-Gujarat-Cab' },
    { title: 'Pune to Lonavala Taxi', imageSrc: '/images/service/8.jpg', toursCount: 3, link: '/Pune-To-Lonavala-Taxi' },
    { title: 'Pune to Jejuri Cab', imageSrc: '/images/service/9.jpg', toursCount: 6, link: '/Pune-To-Jejuri-Cab' },
  ];

  return (
    <>


    <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>Services</h1>
                    </div>
                </div>
            </section>

   
      <section className="elementor-section row-top">
        <div className="container">
          <div className="row mb-5">
           
          </div>
          <div className="row">
            {tours.map((tour, index) => (
              <TourCard
                key={index}
                title={tour.title}
                imageSrc={tour.imageSrc}
                toursCount={tour.toursCount}
                link={tour.link}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BookingBannerSection;
